import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"mt-9 pa-3 full"},[_c(VLayout,{attrs:{"row":"","wrap":""}},_vm._l((_vm.items),function(item,i){return _c(VCard,{key:i,class:`ma-auto ${item.border} pa-3`,attrs:{"to":item.route,"min-width":"400"}},[_c('div',{staticClass:"d-flex flex-column align-center ma-auto`"},[_c(VImg,{staticClass:"mt-4 mb-2",attrs:{"src":item.icon,"width":"175"}}),_c(VCardTitle,{},[_vm._v(_vm._s(item.name))])],1)])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }